<template>
  <div data-cy="review-container" class="max-w-screen-xl mx-auto px-4 mb-8">
    <h2
      data-cy-review-headline="landingpage/reviews/title"
      class="mb-8 uppercase"
    >
      {{ $t('landingpage/reviews/title') }}
    </h2>

    <div class="widget-container">
      <div
        ref="reviewsWidget"
        class="trustpilot-widget"
        :data-locale="localeObject?.iso"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="55247b1b0000ff00057e9ce8"
        data-style-height="140px"
        data-style-width="100%"
        data-theme="dark"
        data-token="c1ba90d4-ef90-4bc6-b8f9-f6ad4bc15606"
        data-stars="5"
        :data-review-languages="localeObject?.code"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const localeObject = useLocaleObject();

const reviewsWidget = ref<HTMLElement | null>(null);

const { initializeTrustpilot } = useTrustpilotWidget(reviewsWidget);

onMounted(() => {
  initializeTrustpilot();
});

useHead({
  script: [
    {
      type: 'text/javascript',
      src: 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
      async: true,
    },
  ],
});
</script>

<style>
.widget-container {
  padding: 20px;
  border-radius: 10px;
}

.trustpilot-widget iframe {
  color-scheme: light;
}
</style>
